import React from 'react';
import './npsQuestion.sass';

const npsOptions = [
  { value: '0', emoji: '😡', className: 'negative-nps' },
  { value: '1', emoji: '😡', className: 'negative-nps' },
  { value: '2', emoji: '😡', className: 'negative-nps' },
  { value: '3', emoji: '😡', className: 'negative-nps' },
  { value: '4', emoji: '😡', className: 'negative-nps' },
  { value: '5', emoji: '😡', className: 'negative-nps' },
  { value: '6', emoji: '😡', className: 'negative-nps' },
  { value: '7', emoji: '😐', className: 'negative-nps' },
  { value: '8', emoji: '😐', className: 'negative-nps' },
  { value: '9', emoji: '😊', className: 'negative-nps' },
  { value: '10', emoji: '😊', className: 'negative-nps' },
];

const NPSQuestion = ({ question, value, onChange, user }) => {
  function handleScore(event) {
    onChange(
      { value: event.target.value, text: event.target.value },
      question.questionID,
      question.questionLevel,
    );
  }

  question.questionText = question.questionText.replace(/\{user\}/gi, user);

  const isRangeScale =
    question.questionType === 'OPEN_ENDED_RANGE_0_10' || question.questionType === 'RANGE_0_10';

  return (
    <div className="nps-container">
      <h4 className="range-score-question">
        <p className="question-text" dangerouslySetInnerHTML={{ __html: question.questionText }} />
      </h4>
      <div className="nps-form">
        <ul className="scale-container">
          {npsOptions.map((option) => (
            <div key={option.value}>
              <label
                className={value === option.value ? `active ${option.className}` : option.className}
              >
                <input
                  type="radio"
                  name="NPS"
                  value={option.value}
                  onChange={handleScore}
                  style={{ display: 'none' }}
                />
                <span>{option.value}</span>
              </label>
              <div>{option.emoji}</div>
            </div>
          ))}
        </ul>
        <div className="scale-indicator">
          <span style={{ color: 'red' }}>
            {isRangeScale ? 'Extremely Dissatisfied' : 'Not at all likely'}
          </span>
          <span style={{ color: 'green' }}>
            {isRangeScale ? 'Extremely Satisfied' : 'Extremely likely'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default NPSQuestion;
